import { combineEpics, ofType } from 'redux-observable';
import { switchMap, catchError, mergeMap } from 'rxjs/operators';
import { normalize } from 'normalizr';
import api from 'api/index';
import { handleError } from 'base/errors/store/actions';
import * as actionTypes from './actionTypes';
import { fetchMyDashboardSuccess, createMyDashboardSuccess, updateMyDashboardSuccess } from './actions';
import { dashboardSchema } from '../../../store/schema';
import { entitiesFetchSuccess } from '../../../store/entities/actions';


const fetchMyDashboard = (action$) => action$.pipe(
  ofType(actionTypes.FETCH),
  switchMap(() => api.myDashboards.fetch().pipe(
    mergeMap((response) => {
      const { entities, result } = normalize(response.body, dashboardSchema);
      return [
        entitiesFetchSuccess(entities),
        fetchMyDashboardSuccess(result),
      ];
    }),
    // It is possible for a user to have no dashboard assigned -> do not treat 404 as error
    // In this case we just show a basic dashboard with minimal widgets
    catchError((error) => ((error.status && [404].includes(error.status))
      ? [fetchMyDashboardSuccess(null)]
      : [handleError(error)])),
  )),
);


const createMyDashboard = (action$) => action$.pipe(
  ofType(actionTypes.CREATE),
  mergeMap((action) => api.myDashboards.create(action.dashboard).pipe(
    mergeMap((response) => {
      const { entities, result } = normalize(response.body, dashboardSchema);
      return [
        entitiesFetchSuccess(entities),
        createMyDashboardSuccess(result),
      ];
    }),
    catchError((error) => [handleError(error)]),
  )),

);


const updateMyDashboard = (action$) => action$.pipe(
  ofType(actionTypes.UPDATE),
  mergeMap((action) => api.myDashboards.update(action.dashboard).pipe(
    mergeMap((response) => {
      const { entities, result } = normalize(response.body, dashboardSchema);
      return [
        entitiesFetchSuccess(entities),
        updateMyDashboardSuccess(result),
      ];
    }),
    catchError((error) => [handleError(error)]),
  )),
);


export default combineEpics(
  fetchMyDashboard,
  createMyDashboard,
  updateMyDashboard,
);
